import * as i0 from '@angular/core';
import * as i1 from './draggable.module';
import * as i2 from './draggable.directive';
import * as i3 from './droppable.directive';
export const DraggableModuleNgFactory:i0.NgModuleFactory<i1.DraggableModule> = (null as any);
var _decl0_0:i2.DraggableDirective = (<any>(null as any));
var _decl0_1:i2.DraggableHandleDirective = (<any>(null as any));
var _decl0_2:i3.DroppableDirective = (<any>(null as any));
var _decl0_3:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_4:i0.ElementRef<any> = (<any>(null as any));
